import { createActions } from 'redux-actions';
import {
  apiActions as commonApiActions,
  apiResourceActionCreator,
  endpointQuery
} from '../../common';
import {
  API_ENDPOINT,
  BUSINESS_ENDPOINT,
  BUSINESS_RESOURCE_ENDPOINT,
  BUSINESS_USER_RESOURCE_ENDPOINT,
  INVITATION_VERIFICATION_ENDPOINT
} from '../endpoints';
import { formatTeamMemberFilter } from './teamMemberFilter';
export const endpoints = {
  Business: {
    AfsLicences: BUSINESS_RESOURCE_ENDPOINT('afs-licences'),
    CpdCategorys: BUSINESS_RESOURCE_ENDPOINT('areas-of-advice'),
    Businesses: BUSINESS_RESOURCE_ENDPOINT('businesses'),
    Industries: BUSINESS_RESOURCE_ENDPOINT('industries'),
    Invitations: BUSINESS_RESOURCE_ENDPOINT('invitations'),
    Subscription: BUSINESS_RESOURCE_ENDPOINT('subscription'),
    TeamCpdCategorys: BUSINESS_RESOURCE_ENDPOINT('team-areas-of-advice'),
    TeamPendingExternalCpd: BUSINESS_RESOURCE_ENDPOINT(
      'team-pending-external-cpd'
    ),
    TeamMembers: BUSINESS_RESOURCE_ENDPOINT('team-members'),
    QueryTeamMembers: BUSINESS_RESOURCE_ENDPOINT('query-team-members'),
    QueryTeamMemberTrainingPlans: BUSINESS_RESOURCE_ENDPOINT(
      'query-team-member-training-plans'
    ),
    UassignedTeamMembers: BUSINESS_RESOURCE_ENDPOINT('unassigned-team-members'),
    InactiveUsers: BUSINESS_RESOURCE_ENDPOINT('inactive-users'),
    InactiveUserCpdActivity:
      BUSINESS_USER_RESOURCE_ENDPOINT('inactive-history'),
    InvitationLink: BUSINESS_RESOURCE_ENDPOINT('invitation-link'),
    Goals: BUSINESS_RESOURCE_ENDPOINT('goals'),
    Profile: BUSINESS_RESOURCE_ENDPOINT('profile'),
    GetBusinessActivities: BUSINESS_RESOURCE_ENDPOINT('activities')
  }
};

export const actions = createActions({
  BUSINESS: {
    API: {
      PROFILE: apiResourceActionCreator('profile'),
      SUBSCRIBE_PLAN: apiResourceActionCreator('subscription'),
      GET_SUBSCRIPTION: apiResourceActionCreator('subscription'),
      CANCEL_SUBSCRIPTION: apiResourceActionCreator('subscription'),
      UPDATE_PAYMENT_DETAILS: apiResourceActionCreator('subscription'),
      GET_AFS_LICENCES: apiResourceActionCreator('afsLicences'),
      ADD_AFS_LICENCE: apiResourceActionCreator('afsLicence'),
      UPDATE_SUBSCRIPTION: apiResourceActionCreator('subscription'),
      GET_BUSINESSES: apiResourceActionCreator('businesses'),
      SEND_INVITATIONS: apiResourceActionCreator('invitations'),
      GET_INVITATIONS: apiResourceActionCreator('invitations'),
      VERIFY_INVITATION: apiResourceActionCreator('invitation'),
      GET_TEAM_MEMBERS: apiResourceActionCreator('teamMembers'),
      QUERY_TEAM_MEMBERS: apiResourceActionCreator('teamMembers'),
      QUERY_TEAM_MEMBER_TRAINING_PLANS: apiResourceActionCreator(
        'teamMemberTrainingPlans'
      ),
      LOAD_MORE_TEAM_MEMBERS: apiResourceActionCreator('teamMembers'),
      GET_UNASSIGNED_TEAM_MEMBERS: apiResourceActionCreator('teamMembers'),
      UPDATE_BUSINESS: apiResourceActionCreator('business'),
      REMOVE_AFS_LICENCE: apiResourceActionCreator('removedAfslNumber'),
      GET_TEAM_CPD_CATEGORYS: apiResourceActionCreator('teamCpdCategorys'),
      GET_TEAM_PENDING_EXTERNAL_CPD: apiResourceActionCreator(
        'teamPendingExternalCpd'
      ),
      GET_SPECIFIC_TEAM_PENDING_EXTERNAL_CPD: apiResourceActionCreator(
        'teamPendingExternalCpd'
      ),
      REMOVE_MEMBER: apiResourceActionCreator('teamMembers'),
      ADD_BUSINESS_ADMIN: apiResourceActionCreator('teamMembers'),
      REMOVE_BUSINESS_ADMIN: apiResourceActionCreator('teamMembers'),
      DELETE_INVITATION: apiResourceActionCreator('invitations'),
      RESEND_INVITATION: apiResourceActionCreator('invitations'),
      GET_CPD_CATEGORYS: apiResourceActionCreator('businessCpdCategorys'),
      SET_CPD_CATEGORYS: apiResourceActionCreator('businessCpdCategorys'),
      SET_TRAINING_PLAN: apiResourceActionCreator('businessCpdCategorys'),
      SET_INDUSTRY_ROLE: apiResourceActionCreator('businessCpdCategorys'),
      SET_PROGRESS_GOALS: apiResourceActionCreator('goals'),
      ADD_INDUSTRY_ROLE: apiResourceActionCreator('industryRoles'),
      GET_INDUSTRY_ROLES: apiResourceActionCreator('industryRoles'),
      UPDATE_INDUSTRY_ROLE: apiResourceActionCreator('industryRole'),
      GET_INACTIVE_USERS: apiResourceActionCreator('inactiveUsers'),
      GET_INACTIVE_USER_CPD_ACTIVITY: apiResourceActionCreator('cpdActivity'),
      GET_INVITATION_LINK: apiResourceActionCreator('invitationLink'),
      ADD_BUSINESS_MANAGER: apiResourceActionCreator('teamMembers'),
      REMOVE_BUSINESS_MANAGER: apiResourceActionCreator('teamMembers'),
      GET_BUSINESS_ACTIVITIES: apiResourceActionCreator('businessActivities'),
      CLEAN_BUSINESS_ACTIVITIES: undefined
    },
    GET_BUSINESSES: undefined,
    GET_SUBSCRIPTION: (businessId) => ({ businessId }),
    GET_INVITATIONS: (businessId) => ({ businessId }),
    GET_TEAM_MEMBERS: (businessId) => ({ businessId }),
    QUERY_TEAM_MEMBERS: (businessId, query) => ({
      businessId,
      query: formatTeamMemberFilter(query)
    }),
    QUERY_TEAM_MEMBER_TRAINING_PLANS: (businessId) => ({ businessId }),
    LOAD_MORE_TEAM_MEMBERS: (businessId, query) => ({
      businessId,
      query: formatTeamMemberFilter(query)
    }),
    GET_UNASSIGNED_TEAM_MEMBERS: (businessId) => ({ businessId }),
    GET_FULL_TEAM_CPD_CATEGORYS: (businessId) => ({ businessId }),
    GET_FULL_TEAM_PENDING_EXTERNAL_CPD: (businessId) => ({ businessId }),
    GET_SPECIFIC_TEAM_PENDING_EXTERNAL_CPD: (businessId, teamId) => ({
      businessId,
      teamId
    }),
    GET_AFS_LICENCES: (businessId) => ({ businessId }),
    PROFILE: (businessId) => ({ businessId }),
    SUBSCRIBE_PLAN: (sourceToken, nextUrl) => ({ sourceToken, nextUrl }),
    SEND_INVITATIONS: (invitationData) => ({ invitationData }),
    UPDATE_SUBSCRIPTION: (subscriptionData) => ({ subscriptionData }),
    CANCEL_SUBSCRIPTION: (businessId) => ({ businessId }),
    UPDATE_PAYMENT_DETAILS: (businessId, source) => ({ businessId, source }),
    ADD_AFS_LICENCE: (afsLicence, nextUrl) => ({ afsLicence, nextUrl }),
    VERIFY_INVITATION: (token, businessId) => ({ token, businessId }),
    UPDATE_BUSINESS: (business) => ({ business }),
    REMOVE_AFSL: (businessId, afslNumber) => ({ businessId, afslNumber }),
    REMOVE_MEMBER: (businessId, memberData) => ({ businessId, memberData }),
    ADD_BUSINESS_ADMIN: (businessId, memberData) => ({
      businessId,
      memberData
    }),
    REMOVE_BUSINESS_ADMIN: (businessId, memberData) => ({
      businessId,
      memberData
    }),
    DELETE_INVITATION: (businessId, invitationId) => ({
      businessId,
      invitationId
    }),
    RESEND_INVITATION: (businessId, invitationId) => ({
      businessId,
      invitationId
    }),
    GET_CPD_CATEGORYS: (businessId) => ({ businessId }),
    SET_CPD_CATEGORYS: (payload) => payload,
    SET_TRAINING_PLAN: (payload) => payload,
    SET_INDUSTRY_ROLE: (payload) => payload,
    SET_PROGRESS_GOALS: (businessId, goals) => ({ businessId, goals }),
    ADD_INDUSTRY_ROLE: (industryBusiness) => ({ industryBusiness }),
    GET_INDUSTRY_ROLES: (businessId) => ({ businessId }),
    GET_INACTIVE_USERS: (businessId) => ({ businessId }),
    GET_INACTIVE_USER_CPD_ACTIVITY: (businessId, userId) => ({
      businessId,
      userId
    }),
    GET_INVITATION_LINK: (businessId) => ({ businessId }),
    INIT_TASK_STACK: (tasks, append) => ({ tasks, append }),
    UPDATE_TASK_STACK: (taskId, status, data) => ({ taskId, status, data }),
    SET_APPLY_TO_ALL_SUCCESS: undefined,
    ADD_BUSINESS_MANAGER: (businessId, memberData) => ({
      businessId,
      memberData
    }),
    REMOVE_BUSINESS_MANAGER: (businessId, memberData) => ({
      businessId,
      memberData
    }),
    GET_BUSINESS_ACTIVITIES: (businessId, yearsOffset, filter) => ({
      businessId,
      yearsOffset,
      filter
    }),
    CLEAN_BUSINESS_ACTIVITIES: undefined
  }
});

export const apiActions = {
  business: {
    // User business resources.
    businesses: (authToken) =>
      commonApiActions.authenticated.get(
        API_ENDPOINT,
        authToken,
        actions.business.api.getBusinesses
      ),
    teamMembers: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.TeamMembers(businessId),
        authToken,
        actions.business.api.getTeamMembers
      ),
    queryTeamMembers: (authToken, businessId, query) =>
      commonApiActions.authenticated.post(
        endpoints.Business.QueryTeamMembers(businessId),
        authToken,
        query || {},
        actions.business.api.queryTeamMembers
      ),
    queryTeamMemberTrainingPlans: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        `${endpoints.Business.QueryTeamMemberTrainingPlans(businessId)}`,
        authToken,
        actions.business.api.queryTeamMemberTrainingPlans
      ),
    loadMoreTeamMembers: (authToken, businessId, query) =>
      commonApiActions.authenticated.post(
        endpoints.Business.QueryTeamMembers(businessId),
        authToken,
        query || {},
        actions.business.api.loadMoreTeamMembers
      ),
    unassignedTeamMembers: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.UassignedTeamMembers(businessId),
        authToken,
        actions.business.api.getUnassignedTeamMembers
      ),
    fullTeamCpdCategorys: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.TeamCpdCategorys(businessId),
        authToken,
        actions.business.api.getTeamCpdCategorys
      ),
    fullTeamPendingExternalCpd: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.TeamPendingExternalCpd(businessId),
        authToken,
        actions.business.api.getTeamPendingExternalCpd
      ),
    specificTeamPendingExternalCpd: (authToken, businessId, teamId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.TeamPendingExternalCpd(businessId, teamId),
        authToken,
        actions.business.api.getSpecificTeamPendingExternalCpd
      ),
    updateBusiness: (authToken, businessId, formData) =>
      commonApiActions.authenticated.postFormData(
        BUSINESS_ENDPOINT(businessId),
        authToken,
        formData,
        actions.business.api.updateBusiness
      ),
    updatePaymentDetails: (authToken, businessId, newPayment) =>
      commonApiActions.authenticated.post(
        BUSINESS_ENDPOINT(businessId, 'update-payment'),
        authToken,
        newPayment,
        actions.business.api.updatePaymentDetails
      ),
    removeMember: (authToken, businessId, memberData) =>
      commonApiActions.authenticated.post(
        BUSINESS_ENDPOINT(businessId, 'remove-member'),
        authToken,
        memberData,
        actions.business.api.removeMember
      ),
    addBusinessAdmin: (authToken, businessId, memberData) =>
      commonApiActions.authenticated.post(
        BUSINESS_ENDPOINT(businessId, 'add-admin'),
        authToken,
        memberData,
        actions.business.api.addBusinessAdmin
      ),
    removeBusinessAdmin: (authToken, businessId, memberData) =>
      commonApiActions.authenticated.post(
        BUSINESS_ENDPOINT(businessId, 'remove-admin'),
        authToken,
        memberData,
        actions.business.api.removeBusinessAdmin
      ),
    addBusinessManager: (authToken, businessId, memberData) =>
      commonApiActions.authenticated.post(
        BUSINESS_ENDPOINT(businessId, 'add-manager'),
        authToken,
        memberData,
        actions.business.api.addBusinessManager
      ),
    removeBusinessManager: (authToken, businessId, memberData) =>
      commonApiActions.authenticated.post(
        BUSINESS_ENDPOINT(businessId, 'remove-manager'),
        authToken,
        memberData,
        actions.business.api.removeBusinessManager
      ),
    getInactiveUsers: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.InactiveUsers(businessId),
        authToken,
        actions.business.api.getInactiveUsers
      ),
    getInactiveUserCpdActivity: (authToken, businessId, userId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.InactiveUserCpdActivity(businessId, userId),
        authToken,
        actions.business.api.getInactiveUserCpdActivity
      ),
    profile: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.Profile(businessId),
        authToken,
        actions.business.api.profile
      ),
    getBusinessActivities: (authToken, businessId, yearsOffset, filter) =>
      commonApiActions.authenticated.get(
        `${endpoints.Business.GetBusinessActivities(businessId)}${endpointQuery({ ...(filter || {}), ...(yearsOffset !== undefined ? { yearsOffset } : {}) })}`,
        authToken,
        actions.business.api.getBusinessActivities
      ),
    cleanBusinessActivities: () => ({
      type: actions.business.cleanBusinessActivities().type
    }),
    // AFSL resources.
    addAfsLicence: (authToken, businessId, payload) =>
      commonApiActions.authenticated.post(
        endpoints.Business.AfsLicences(businessId),
        authToken,
        payload,
        actions.business.api.addAfsLicence
      ),
    getAfsLicences: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.AfsLicences(businessId),
        authToken,
        actions.business.api.getAfsLicences
      ),
    removeAfsLicence: (authToken, businessId, afslNumber) =>
      commonApiActions.authenticated.delete(
        endpoints.Business.AfsLicences(businessId, afslNumber),
        authToken,
        actions.business.api.removeAfsLicence
      ),

    // Invitations.
    sendInvitations: (authToken, businessId, payload) =>
      commonApiActions.authenticated.post(
        endpoints.Business.Invitations(businessId),
        authToken,
        payload,
        actions.business.api.sendInvitations
      ),
    invitations: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.Invitations(businessId),
        authToken,
        actions.business.api.getInvitations
      ),
    verifyInvitation: (payload) =>
      commonApiActions.post(
        INVITATION_VERIFICATION_ENDPOINT,
        payload,
        actions.business.api.verifyInvitation
      ),
    deleteInvitation: (authToken, businessId, invitationId) =>
      commonApiActions.authenticated.delete(
        endpoints.Business.Invitations(businessId, invitationId),
        authToken,
        actions.business.api.deleteInvitation
      ),
    resendInvitation: (authToken, businessId, invitation) =>
      commonApiActions.authenticated.post(
        endpoints.Business.Invitations(businessId, 'resend'),
        authToken,
        invitation,
        actions.business.api.resendInvitation
      ),
    getInvitationLink: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.InvitationLink(businessId),
        authToken,
        actions.business.api.getInvitationLink
      ),

    // Business subscriptions.
    subscribePlan: (authToken, businessId, payload) =>
      commonApiActions.authenticated.post(
        endpoints.Business.Subscription(businessId),
        authToken,
        payload,
        actions.business.api.subscribePlan
      ),
    subscription: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.Subscription(businessId),
        authToken,
        actions.business.api.getSubscription
      ),
    updateSubscription: (authToken, businessId, payload) =>
      commonApiActions.authenticated.put(
        endpoints.Business.Subscription(businessId),
        authToken,
        payload,
        actions.business.api.updateSubscription
      ),
    cancelSubscription: (authToken, businessId) =>
      commonApiActions.authenticated.post(
        endpoints.Business.Subscription(businessId, 'cancel'),
        authToken,
        {},
        actions.business.api.cancelSubscription
      ),

    getCpdCategorys: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.CpdCategorys(businessId),
        authToken,
        actions.business.api.getCpdCategorys
      ),
    setCpdCategorys: (authToken, businessId, payload) =>
      commonApiActions.authenticated.post(
        endpoints.Business.CpdCategorys(businessId),
        authToken,
        payload,
        actions.business.api.setCpdCategorys
      ),

    // Industry resources.
    industryRoles: (authToken, businessId) =>
      commonApiActions.authenticated.get(
        endpoints.Business.Industries(businessId),
        authToken,
        actions.business.api.getIndustryRoles
      ),
    addIndustryRole: (authToken, businessId, payload) =>
      commonApiActions.authenticated.post(
        endpoints.Business.Industries(businessId),
        authToken,
        payload,
        actions.business.api.addIndustryRole
      ),
    updateIndustryRole: (authToken, businessId, industryBusiness) =>
      commonApiActions.authenticated.post(
        endpoints.Business.Industries(
          businessId,
          industryBusiness.industryBusiness.id
        ),
        authToken,
        industryBusiness,
        actions.business.api.updateIndustryRole
      ),

    // Business Goals
    setProgressGoals: (authToken, businessId, goals) =>
      commonApiActions.authenticated.post(
        endpoints.Business.Goals(businessId),
        authToken,
        goals,
        actions.business.api.setProgressGoals
      )
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/business/business/actions.js